import '@site/styles/sass/styles.scss';

import $ from 'jquery';
import 'jquery-migrate';
import './vendor/jquery-ui.min.js';
import 'slick-carousel';
import Isotope from 'isotope-layout';
import jQueryBridget from 'jquery-bridget';
import 'jquery-validation';
import Masonry from 'masonry-layout';
import './vendor/niceSelect.js';
import { transEndEventName, scrollTop, addClass, removeClass, hasClass, toggleClass, nextSibling } from './plugins.js';
import MatchesFilter from './modules/filter.js';
import './map.js';

window.$ = window.jQuery = $;
jQueryBridget('isotope', Isotope, $ );
jQueryBridget('masonry', Masonry, $ );

window.CaptchaCallback = function() {
    $(".g-recaptcha").each(function() {
        var el = $(this);
        grecaptcha.render($(el).attr("id"), {
            'sitekey' : '6Le-2KYUAAAAANW6hJx-Ru9louH8h9ViGd-jm2-Y',
            'callback' : function(token) {
                $(el).parent().find(".hiddenRecaptcha").val(token);
            }
        });
    });
};
window.correctCaptcha_formz = function(response) {
    $("#formzCaptcha").val(response);
};
window.correctCaptcha_second = function(response) {
    $("#secondCaptcha").val(response);
};
window.correctCaptcha_first = function(response) {
    $("#firstCaptcha").val(response);
};

// Dynamically load the reCAPTCHA script
const script = document.createElement("script");
script.src = "https://www.google.com/recaptcha/api.js?onload=CaptchaCallback&render=explicit";
script.async = true;
script.defer = true;
document.head.appendChild(script);

$('.breadcrumbs').each(function(index, element) {
	if(index > 0)
		element.remove(); // Removes all but first
	else
		if($('.hero-carousel'))
			$('.breadcrumbs').insertAfter( ".hero-carousel"); // If carousel - move into correct position
			element.classList.toggle('force-relative'); // Show it
});

// -------
// IFrames
// -------
window.resizeIframe = function(obj) {
	obj.style.height = obj.contentWindow.document.body.scrollHeight + 'px';

	setTimeout(function(){
		resizeIframe(obj);
	}, 500);
}

$(document).ready(function(){
	var _window = $(window),
		maps = [];

	// ---
	// Nav
	// ---
	// Navigate when nav select is changed (for mobile)
	$('.nav-select').on('change', 'select', function(){
		if (this.value !== '')
			window.location = this.value;
	});

	$('.nav-content')
		.each(function(index, element){
			var _childEls = element.querySelectorAll('li');

			var top = null;

			for (var i = 0; i < _childEls.length; i++) {
				removeClass(_childEls[i], 'first-in-line');
				if (_childEls[i].offsetTop !== top) {
					top = _childEls[i].offsetTop;
					addClass(_childEls[i], 'first-in-line');
				}
			}
		});

	$('.js-mobile-search')
		.on('click', function(){
			toggleClass(document.getElementById('search-form'), 'open');
		});


	$('.js-toggle-home-col')
		.on('click', function(){
			toggleClass(document.querySelector('.home-col'), 'open');
		});

	// Automatically set links with a different domain to open in a new window
	$('a[href^=http]')
		.each(function(index, elLink){
			if(this.href.indexOf(window.location.hostname) < 0) {
				this.target = '_blank';
				this.setAttribute('rel', 'external');
			}
        });

    $('div[data-href]')
		.each(function(index, el){
            $(this).on('click', function(e) {
                window.location.href = $(this).data('href');
            });
        });

	// -----------
	// Nice Select
	// -----------
	$('.js-niceselect').niceSelect();
	$('.content-block-formz select').niceSelect();


	// -----------------
	// Email Obfuscation
	// -----------------
	$('.js-email-hidden')
		.each(function(index, element){
			setText(element, element.getAttribute('data-user') + '@' + element.getAttribute('data-domain'));

			element.href = 'mailto:' + element.getAttribute('data-user') + '@' + element.getAttribute('data-domain');
		});


	// --------------
	// External Links
	// --------------
	$('[rel=external]')
		.attr('target', '_blank')
		.on('click', function(){
			// ga('send', 'event', 'outbound', 'click', this.href);
			ga('send', 'event', 'link', 'click', window.location, this.href);
		});


	// --------------
	// Image Captions
	// --------------
	$('img[title]').each(function(index, element){
		var _image = $(this),
			__figure = $('<figure />'),
			__figcaption = $('<figcaption />');

		var f = this.style.cssFloat || this.style.styleFloat || false;

		if (f === 'left') {
			__figure.addClass('fig-left');
		} else if (f === 'right') {
			__figure.addClass('fig-right');
		}

		_image
			.addClass('fig-img')
			.after(__figure);

		__figcaption
			.text(_image.attr('title'));

		__figure
			.append(_image)
			.append(__figcaption);

		__figure
			.css({
				paddingBottom: __figcaption.outerHeight()
			});

		_image = null;
		__figure = null;
		__figcaption = null;
	});

	// ----------
	// Directions
	// ----------
	$('.content-block-directions')
		.each(function(index, element){
			// Elements
			var _expander = element.querySelector('.directions-expand'),
				_inner = element.querySelector('.inner'),
				_modeSelect = element.querySelector('.mode-select'),
				_modeSelectLinks = _modeSelect.querySelectorAll('a'),
				_modeSelectJQ = $(_modeSelect),
				_summary = document.querySelectorAll('.directions-summary');

			// Variables
			var mode = null;


			_modeSelectJQ
				.on('click', 'a', function(event){
					event.preventDefault();

					//
					for (var i = 0; i < _summary.length; i++) {
						removeClass(_summary[i], 'active');
					}
					addClass(document.getElementById('directions-summary-'+this.getAttribute('data-mode')), 'active');

					//
					_expander.style.height = _inner.offsetHeight + 'px';

					for (var i = 0; i < _modeSelectLinks.length; i++) {
						removeClass(_modeSelectLinks[i], 'active');
					}

					addClass(this, 'active');

					var _mode = document.querySelector('[name=mode]');
					if (_mode) {
						_mode.value = this.getAttribute('data-mode');
					}

					if (mode !== this.getAttribute('data-mode')) {
						$('.js-directions')
							.children()
								.remove();
					}

					mode = this.getAttribute('data-mode');

					_modeSelectJQ
						.trigger('updateHeight');

					// if (window.matchMedia) {
					// 	mq = window.matchMedia( "(max-width: 767px)" );

					// 	if (mq.matches) {
					// 		var rect = _expander.getBoundingClientRect();
					// 		window.scrollTo(0, rect.top + scrollTop());
					// 	}
					// }

					var rect = element.getBoundingClientRect();
					$('body,html').animate({ scrollTop: rect.top + scrollTop() });
				})
				.on('updateHeight', function(event){
					_expander.style.height = _inner.offsetHeight + 'px';
				})
				.on('close', function(event){
					_expander.style.height = '0px';
				});

			$(element.querySelector('.js-map-close'))
				.on('click', function(event){
					_modeSelectJQ
						.trigger('close');

					for (var i = 0; i < _modeSelectLinks.length; i++) {
						removeClass(_modeSelectLinks[i], 'active');
					}
				});


		});


	// ----
	// FAQs
	// ----
	$('.content-block-faqs')
		.each(function(index, element){
			var _category = element,
				_list = element.querySelector('.list'),
				_dl = element.querySelector('dl');

			$(element.querySelector('h3'))
				.on('click', function(event){
					var h = 0;
					toggleClass(_category, 'active');

					if (hasClass(_category, 'active')) {
						h = _dl.offsetHeight;
					} else {
						_list.style.minHeight = '';
						_list.style.height = _list.offsetHeight+'px';
					}

					setTimeout(function(){
						_list.style.height = h+'px';
					}, 0);
				});

			$(element.querySelectorAll('dt'))
				.on('click', function(event){
					var h = 0,
						_dt = nextSibling(this),
						_inner = _dt.querySelector('.inner');

					toggleClass(this, 'active');

					if (hasClass(this, 'active')) {
						h = _inner.offsetHeight;
					}

					_dt.style.height = h+'px';
				});

			$(_list)
				.on(transEndEventName, function(){
					if (hasClass(_category, 'active')) {
						_list.style.minHeight = _list.style.height;
						_list.style.height = 'auto';
					}
				});

		});


	// -----
	// Squad
	// -----

	$('.squad')
		.each(function(index, element){
			var _items = element.querySelectorAll('.item'),
				_cards = element.querySelectorAll('.card'),
				_titles = element.querySelectorAll('.name'),
				_pictures = element.querySelectorAll('.picture'),
				_grid = element.querySelector('.grid'),
				_filters = element.querySelectorAll('.js-filter'),
				_filterRole = element.querySelector('[name=role]'),
				_orderby = element.querySelectorAll('.js-orderby');

			var buildFilter = function(){
				var output = '';

				for (var i = 0; i < _filters.length; i++) {
					if (_filters[i].value !== '') {
						output += '[data-'+_filters[i].name+'*='+_filters[i].value+']'
					}
				}

				return output;
			};

			$(_grid).isotope({
				itemSelector: '.item',
				layoutMode: 'fitRows'
			});

			$(_grid).isotope({ filter: buildFilter() });

			$(_cards)
				.on('click', function(event){
					var reverse = false;
					if (hasClass(this, 'flipped')) {
						reverse = true;
					}
					for (var i = 0; i < _cards.length; i++) {
						removeClass(_cards[i], 'flipped');
					}

					if (!reverse) {
						addClass(this, 'flipped');
					}
				});

			$(_filters)
				.on('change', function(event){
					$(_grid).isotope({ filter: buildFilter() });

					if (window.history.pushState) {
						var stateObj = {};
						var newpath = window.location.protocol+'//'+window.location.hostname+window.location.pathname+'?'+$(this.form).serialize();
						history.pushState(stateObj, document.title, newpath);
					}
				});

			$(_orderby)
				.on('change', function(){
					this.form.submit();
				});

			if (window.location.search) {
				var query = _ad.qString(window.location.search);
			}


			_ad.checkHeight($(_pictures), false, false);
			_window
				.on('resize', function(){
					_ad.checkHeight($(_pictures), false, false);
					$(_grid).isotope('layout');
				});

			setTimeout(function(){
				_ad.checkHeight($(_pictures), false, false);
				$(_grid).isotope('layout');
			}, 1000);
		});


	// -------
	// Matches
	// -------
	$('.content-block-matches')
		.each(function(index, element){
            const filter = new MatchesFilter(element);
            filter.init();
        });

	$('.content-block-matches-no')
		.each(function(index, element){

			// Variables
			var _filters = element.querySelectorAll('.js-filter'),
				_rows = element.querySelectorAll('.row'),
				_primary = element.querySelector('.js-filter-primary'),
				_secondary = element.querySelector('.js-filter-secondary'),
				_dates = element.querySelector('.js-filter-dates'),
				_secondaryOpts = _secondary.querySelectorAll('option'),
				_datesOpts = _dates.querySelectorAll('option'),
				secondaryOpts = {},
				dateOpts = {},
				currentFilters = {},
				currentFiltersString = '';

			for (var i = 0, len = _secondaryOpts.length; i < len; i++) {
				var index = _secondaryOpts[i].value;
				index = index === '' ? '0' : index;
				secondaryOpts[index] = _secondaryOpts[i];
			}

			for (var i = 0, len = _datesOpts.length; i < len; i++) {
				var index = _datesOpts[i].value;
				index = index === '' ? '0' : index;
				dateOpts[index] = _datesOpts[i];
			}

			// Functions
			var showRow = function(_rowEl){
				removeClass(_rowEl, 'hidden');

				setTimeout(function(){
					removeClass(_rowEl, 'hiding');
				}, 100);
			};
			var hideRow = function(_rowEl) {
				if (arguments[1] === true) addClass(_rowEl, 'hidden');
				addClass(_rowEl, 'hiding');
				if (!Modernizr.csstransitions) addClass(_rowEl, 'hidden');
				// Tidy up after Safari
				setTimeout(function(){
					if (hasClass(_rowEl, 'hiding')) {
						addClass(_rowEl, 'hidden');
					}
				}, 350);
			};
			var filterItems = function(name, value, items){
				var _output = [];
				if (value !== '') {
					for (var i = 0; i < items.length; i++) {
						if ((items[i].getAttribute('data-'+name) == value)) {
							_output.push(items[i]);
						}
					}
				} else {
					_output = items;
				}

				return _output;
			};
			var updateFilter = function(items){
				var types = [];
				for (var i = 0; i < items.length; i++) {
					var type = items[i].getAttribute('data-type');

					if (types.indexOf(type) === -1) {
						types.push(type);
					}
				}
				var years = [];
				for (var i = 0; i < items.length; i++) {
					var type = items[i].getAttribute('data-year');

					if (years.indexOf(type) === -1) {
						years.push(type);
					}
				}

				// Deal with the secondary filter //
				var options = _secondary.querySelectorAll('option');
				for (var i = 0; i < options.length; i++) {
					options[i].parentNode.removeChild(options[i]);
				}
				for (var i = 0; i < types.length; i++) {
					_secondary.appendChild(secondaryOpts[types[i]]);
				}

				if (_primary.value == '355' || _primary.value == '358' || _primary.value == '682') {
					_secondary.insertBefore(secondaryOpts['0'], _secondary.firstChild);
				}

				var _selected = $(_secondary).children('[value="'+currentFilters.type+'"]');

				if (_selected.length) {
					$(_secondary)
						.val(currentFilters.type);
				} else {
					$(_secondary)
						.val($(_secondary).children('option:first').attr('value'));
				}

				$(_secondary)
					.trigger('change')

				// Deal with the dates filter //
				var options = _dates.querySelectorAll('option');
				for (var i = 0; i < options.length; i++) {
					options[i].parentNode.removeChild(options[i]);
				}
				for (var i = 0; i < years.length; i++) {
					_dates.appendChild(dateOpts[years[i]]);
				}

				var _selected = $(_dates).children('[value="'+currentFilters.year+'"]');

				if (_selected.length) {
					$(_dates)
						.val(currentFilters.year);
				} else {
					$(_dates)
						.val($(_dates).children('option:first').attr('value'));
				}

				$(_dates)
					.trigger('change');
			};

			var funcSetCurrentFilters = function(){
				$(_filters).each(function(index, el){
					currentFilters[el.name] = el.value;
				});
			};



			var qFilters = _ad.qString(location.search);

			if (qFilters) {
				for (var key in qFilters) {
					var elSelect = document.querySelector('[name="'+key+'"]');
					elSelect.value = qFilters[key];
				}
			}

			funcSetCurrentFilters();

			var _items = _rows;
			$(_filters).each(function(index, el){
				_items = filterItems(el.name, el.value, _items);

			});
			for (var i = 0; i < _items.length; i++) {
				addClass(_items[i], 'showthis');
				removeClass(_items[i], 'alt');

				if (i % 2 == 0) {
					addClass(_items[i], 'alt');
				}
			}
			for (var i = 0; i < _rows.length; i++) {
				if (!hasClass(_rows[i], 'showthis')) {
					hideRow(_rows[i], true);
				} else {
					showRow(_rows[i]);
					removeClass(_rows[i], 'showthis');
				}
			}

			if (history.pushState) {
				window.onpopstate = function(event){
					var qFilters = _ad.qString(location.search);

					if (qFilters) {
						for (var key in qFilters) {
							var elSelect = document.querySelector('[name="'+key+'"]');
							elSelect.value = qFilters[key];
						}
						// $(_filters).trigger('change');
					}
				};
			}

			$(_filters)
				.on('change', function(event){
					var _items = _rows;

					var qObj = {},
						q = '';

					$(_filters).each(function(index, el){
						_items = filterItems(el.name, el.value, _items);
						qObj[el.name] = el.value;
					});


					/// Push the updated filter values to the URL/History
					for (var key in qObj) {
						if (q !== '') q += '&';
						q += key+'='+qObj[key];
					}

					if (history.pushState) {
						if (currentFiltersString !== q) {
							var href = location.protocol + '//' + location.host + location.pathname;
							history.pushState({}, '', href + '?'+q);
						}
						currentFiltersString = q;
					}
					///


					for (var i = 0; i < _items.length; i++) {
						addClass(_items[i], 'showthis');
						removeClass(_items[i], 'alt');

						if (i % 2 == 0) {
							addClass(_items[i], 'alt');
						}
					}
					for (var i = 0; i < _rows.length; i++) {
						if (!hasClass(_rows[i], 'showthis')) {
							hideRow(_rows[i]);
						} else {
							removeClass(_rows[i], 'hidden');
							removeClass(_rows[i], 'hiding');
							showRow(_rows[i]);
							removeClass(_rows[i], 'showthis');
						}
					}

					funcSetCurrentFilters();
				});

			$(_rows)
				.on(transEndEventName, function(event){
					if (hasClass(this, 'hiding')) addClass(this, 'hidden');
				});

			$(_primary)
				.on('change', function(){
					var _items = _rows,
						_primaryItems = filterItems(this.name, this.value, _items);

					updateFilter(_primaryItems);
				})
				.change();

			if (qFilters) {
				$(_filters).trigger('change');
			}
		});


	// ----------
	// Ageas Live
	// ----------
	function arrUnique(arr) {
		var newArr = [],
			currItem;

		while(arr.length > 0) {
			currItem = arr.shift();
			if (newArr.indexOf(currItem) < 0){
				newArr.push(currItem);
			}
		}
		return newArr;
	}
	$('.content-block-live')
		.each(function(index, element){
			// Objects
			var _this = $(element),
				_inner = $(element.querySelector('.blocks')),
				_filters = element.querySelectorAll('.js-filter'),
				_blocks = element.querySelectorAll('.block');

			// Set up month heading blocks //
			var dates = {},
				months = {},
				years = {},
				competitions = {};

			$(_blocks)
				.each(function(index, el){
					var month = el.getAttribute('data-month'),
						year = el.getAttribute('data-year'),
						ev = el.getAttribute('data-event');

					if (!competitions[month]) competitions[month] = [];
					if (ev) competitions[month].push(ev);

					if (dates[year + '-' + month] !== true) {
						var _monthEl = $('<div class="block month" data-year="'+year+'" data-month="'+month+'"><div class="inner"><div class="inner-content"><div class="text">'+month+'<span class="year">'+year+'</span></div></div></div></div>');
						_monthEl.insertBefore(this);
					}
					months[month] = true;
					years[year] = true;
					dates[year + '-' + month] = true;
				});

			var elMonths = document.querySelectorAll('.month');
			for (var key in months) {
				var elMonth;
				for (var i = 0, len = elMonths.length; i < len; i++) {
					if (elMonths[i].getAttribute('data-month') === key) {
						elMonth = elMonths[i];
					}
				}
				if (!elMonth) return false;

				var str = arrUnique(competitions[key].toString().split(',')).toString();
				elMonth.setAttribute('data-event', str);
			}


			// Build Filters //
			var _filterYear = $('[name=year]'),
				_filterMnth = $('[name=month]');
			for (var x in years) {
				var opt = $('<option>'+x+'</option>');
				_filterYear.append(opt);
			}
			for (var x in months) {
				var opt = $('<option>'+x+'</option>');
				_filterMnth.append(opt);
			}
			_filterYear.trigger('change');
			_filterMnth.trigger('change');

			// _inner.isotope({
			// 	itemSelector: '.block'
			// });

			// Functions
			var showRow = function(el){
				removeClass(el, 'hidden');

				setTimeout(function(){
					removeClass(el, 'hiding');
				}, 100);
			};
			var filterItems = function(name, value){
				if (value !== '') {
					for (var i = 0; i < _blocks.length; i++) {
						if ((_blocks[i].getAttribute('data-'+name) != value)) {
							addClass(_blocks[i], 'hiding');
							if (!Modernizr.csstransitions) addClass(_blocks[i], 'hidden');
						}

						if ((_blocks[i].getAttribute('data-'+name) == value)) {
							showRow(_blocks[i]);
						}
					}
				} else {
					for (var i = 0; i < _blocks.length; i++) {
						showRow(_blocks[i]);
					}
				}
			};
			var buildFilter = function(){
				var output = '';

				for (var i = 0; i < _filters.length; i++) {
					if (_filters[i].value !== '') {
						output += '[data-'+_filters[i].name+'*='+_filters[i].value+']'
					}
				}

				return output;
			};

			// Events
			$(_filters)
				.on('change', function(event){
					var select = this;
					_inner.isotope({ filter: buildFilter() });
				});
		});

	//AJML - Added to capture filter values and trigger download of ICS
	$(".calendar-multiple-fixtures").on('click', function(event) {
		//Prevent default event handling
		event.preventDefault();

		//Extract the filter values and build the URI
		var squad = $(".filters select[name=squad]").val();
		var type = $(".filters select[name=type]").val();
		if(!type) { type = 0; }
		var ground = $(".filters select[name=ground]").val();
		if(!ground) { ground = 0; }

		var dmn = window.location.protocol + '//' + window.location.hostname;

		// window.location = 'calendar-multiple-fixtures/?squad='+squad+'&type='+type+'&ground='+ground;
		location.href = '/calendar-multiple-fixtures/?squad='+squad+'&type='+type+'&ground='+ground;
		// location.href = dmn + '/calendar-multiple-fixtures/?squad='+squad+'&type='+type+'&ground='+ground;
	});

	// -----
	// Video
	// -----
	$('.content-block-video')
		.on('click', '.img', function(event){
			addClass(this, 'fade');
			addClass(nextSibling(this), 'fade');
		})
		.on(transEndEventName, '.img', function(){
			addClass(this, 'faded');
		});

	// ----
	// Tabs
	// ----
	$('.js-tabs').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						removeClass(sibl[i], 'show');
				}
				addClass(tab, 'show');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i], 'active');
				}
				addClass(this, 'active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + _ad.window.scrollTop() });
				}

				subsequentClick = true;
			})
			.each(function(){})
			.first()
			.click();

		_ad.checkHeight(_links, false, false);
		_window.on('resize', function(){
			//_ad.checkHeight(_links);
		});
	});


	// ----
	// Tabs
	// ----
	$('.js-tabs2').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs2-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						removeClass(sibl[i], 'show');
				}
				addClass(tab, 'show');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i], 'active');
				}
				addClass(this, 'active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + _ad.window.scrollTop() });
				}

				subsequentClick = true;
			})
			.each(function(){})
			.first()
			.click();

		_ad.checkHeight(_links, false, false);
		_window.on('resize', function(){
			//_ad.checkHeight(_links);
		});
	});

	// ----
	// Tabs
	// ----
	$('.js-tabs3').each(function(index, el){
		var mq = {},
			tabs = el,
			links = tabs.querySelectorAll('.js-tabs3-links a'),
			_links = $(links),
			subsequentClick = false;

		if (window.matchMedia) {
			mq = window.matchMedia( "(max-width: 767px)" );
		} else {
			mq.matches = false;
		}

		_links
			.on('click', function(ev){
				ev.preventDefault();

				var tab = document.querySelector(this.href.substr(this.href.indexOf('#'))),
					sibl = tab.parentNode.children;

				// Show Tab Content
				for (var i = 0; i < sibl.length; i++) {
					if (sibl[i] !== tab)
						removeClass(sibl[i], 'show');
				}
				addClass(tab, 'show');

				// Highlight Tab Link
				for (var i = 0; i < links.length; i++) {
					if (links[i] !== tab)
						removeClass(links[i], 'active');
				}
				addClass(this, 'active');

				if (mq.matches && subsequentClick) {
					// scroll to the top of the tabs to highlight //
					var rect = tabs.getBoundingClientRect();
					$('html, body')
						.animate({ scrollTop: rect.top + _ad.window.scrollTop() });
				}

				subsequentClick = true;
			})
			.each(function(){})
			.first()
			.click();

		_ad.checkHeight(_links, false, false);
		_window.on('resize', function(){
			//_ad.checkHeight(_links);
		});
	});

	$('.content-block-cricket')
		.each(function(index, el){
			var tabs = el,
				links = tabs.querySelectorAll('.js-tabs-links a'),
				_links = $(links),
				content = tabs.querySelectorAll('.tabs-content'),
				_content = $(content);

			var funcSetHeights = function(mq){
				var elTabNext = document.getElementById('side-tab-next'),
					elTabNextInr = elTabNext.querySelector('.fixture'),
					elTabLast = document.getElementById('side-tab-last'),
					elTabLastInr = elTabLast.querySelector('.fixture'),
					elTabIntl = document.getElementById('side-tab-international');

                if (elTabIntl) var elTabIntlInr = elTabIntl.querySelector('.fixture');

				if (mq.matches) {
					var padTop;

					if (elTabNextInr) elTabNextInr.style.paddingTop = '';
					if (elTabLastInr) elTabLastInr.style.paddingTop = '';
					if (elTabIntlInr) elTabIntlInr.style.paddingTop = '';

					_ad.checkHeight(_content, false, false, true);

					setTimeout(function(){
						if (elTabNextInr) {
							padTop = ((elTabNext.offsetHeight - 24) - elTabNextInr.offsetHeight) / 2;
							elTabNextInr.style.paddingTop = padTop + 'px';
						}

						if (elTabLastInr) {
							padTop = ((elTabLast.offsetHeight - 24) - elTabLastInr.offsetHeight) / 2;
							elTabLastInr.style.paddingTop = padTop + 'px';
						}

						if (elTabIntlInr) {
							padTop = ((elTabIntl.offsetHeight - 24) - elTabIntlInr.offsetHeight) / 2;
							elTabIntlInr.style.paddingTop = padTop + 'px';
						}
					}, 10);
				} else {
					_content.css("min-height", "0");
					if (elTabNextInr) elTabNextInr.style.paddingTop = '';
					if (elTabLastInr) elTabLastInr.style.paddingTop = '';
					if (elTabIntlInr) elTabIntlInr.style.paddingTop = '';
				}
			};

			_links
				.on('click', function(ev){
					// _ad.checkHeight(_content);
				});

			var mq = {};

			if (window.matchMedia) {
				mq = window.matchMedia( "(min-width: 1024px)" );
			} else {
				mq.matches = false;
			}

			if (mq.addListener) {
				mq.addListener(funcSetHeights);
			}

			funcSetHeights(mq);

			setTimeout(function(){
				funcSetHeights(mq);
			}, 1000);
		});


	// ------------
	// Promo Blocks
	// ------------
	$('.content-block-promo')
		.each(function(index, element){
			var _els = $(element.querySelectorAll('.text'));

			var mq = {};

			if (window.matchMedia) {
				mq = window.matchMedia( "(min-width: 768px)" );
			} else {
				mq.matches = false;
			}

			if (mq.matches) _ad.checkHeight(_els, false, false);
		});


	// -----------------
	// Membership Blocks
	// -----------------
	$('.content-block-ticket')
		.each(function(index, element){
			var _els = $(element.querySelectorAll('.benefits'));

			var mq = {};

			if (window.matchMedia) {
				mq = window.matchMedia( "(min-width: 768px)" );
			} else {
				mq.matches = false;
			}

			if (mq.matches) _ad.checkHeight(_els, false, false);
		});


	// -----------------
	// Membership Blocks
	// -----------------
	$('.nav-tabs')
		.each(function(index, element){
			var _els = $(element.querySelectorAll('ul ul'));

			var mq = {};

			if (window.matchMedia) {
				mq = window.matchMedia( "(min-width: 768px)" );
			} else {
				mq.matches = false;
			}

			if (mq.matches) _ad.checkHeight(_els, false, false);
		});


	// -------
	// Storify
	// -------
	function expandStorify(storifyEl) {
		var iframe = storifyEl.querySelector('iframe'),
			wrap = storifyEl.querySelector('.storify-wrap');

		wrap.style.height = iframe.offsetHeight + 'px';
		wrap.style.paddingBottom = '1px';

		addClass(storifyEl, 'fade');
	}
	$('.js-storify-expand')
		.on('click', function(event){
			expandStorify(document.querySelector('.storify'));
		})
		.on(transEndEventName, function(){
			if (hasClass(document.querySelector('.storify'), 'fade')) {
				addClass(this, 'hidden');
			}
		});

	$('.js-storify-competition-expand')
		.on('click', function(event){
			expandStorify(document.querySelector('.storify-competition'));
		});


	// -------------
	// Expand Blocks
	// -------------
	$('.js-expand')
		.each(function(index, element){
			var _this = $(element);

			_this
				.on('toggle', function(){
					var _root = element,
						_expandContent = _root.querySelector('.expand-content'),
						_expandInner = _expandContent.querySelector('.expand-content-inner'),
						elHeight = 0;
					toggleClass(element, "open");

					if (hasClass(element, "open")) {
						elHeight = _expandInner.offsetHeight;
					}

					_expandContent.style.height = elHeight+'px';

					if (hasClass(element, "open")) {
						var rect = element.getBoundingClientRect();
						$('body,html').animate({ scrollTop: rect.top + scrollTop() });
					}
				});

			_this.on('click', '.js-expand-title', function(event){
				_this
					.trigger('toggle');
			});
		});



	// --------------
	// Slick Carousel
	// --------------
	// $('.js-slick-carousel').slick({
	// 	dots: true,
	// 	infinite: false,
	// 	speed: 300,
	// 	slidesToShow: 4,
	// 	slidesToScroll: 4,
	// 	responsive: [{
	// 		breakpoint: 1024,
	// 		settings: {
	// 			slidesToShow: 3,
	// 			slidesToScroll: 3,
	// 			infinite: true,
	// 			dots: true
	// 		}
	// 	}, {
	// 		breakpoint: 600,
	// 		settings: {
	// 			slidesToShow: 2,
	// 			slidesToScroll: 2
	// 		}
	// 	}, {
	// 		breakpoint: 480,
	// 		settings: {
	// 			slidesToShow: 1,
	// 			slidesToScroll: 1
	// 		}
	// 	}]
	// });

	$('.js-slick-carousel').slick({
		dots: true,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 0,
	});

	$('.js-slick-home-carousel').slick({
		autoplay: true,
		autoplaySpeed: 2000,
		dots: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		slidesToScroll: 1,
		rows: 0,
	});

	$('.js-thumbs-slider')
		.slick({
			dots: false,
			infinite: true,
			speed: 300,
			slidesToShow: 3,
			slidesToScroll: 1
		})
		.on('click', 'img', function(){
			var _img = document.getElementById('gallery-side-main');
			_img.src = this.src;
		})
		.each(function(){
			var _img = document.getElementById('gallery-side-main'),
				_firstImg = this.querySelector('img');

			_img.src = _firstImg.src;
		});

	$('.js-hero-carousel').slick({
		arrows: true,
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		verticalSwiping: false,
		autoplay: true,
		rows: 0,
	});


	// -------
	// Gallery
	// -------
	const $glightboxCarousel = $('#glightbox-carousel');
	$glightboxCarousel.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
	});

	$glightboxCarousel.on('click', '.glightbox-trigger', function (e) {
		e.stopPropagation();
		e.preventDefault();

		const href = $(this).data('href');
		const title = $(this).data('title');
		import('glightbox').then(({ default: GLightbox }) => {
			const lightbox = GLightbox({
				elements: [{
					href,
					title,
					type: 'image'
				}],
				loop: true
			});
			lightbox.open();
		});
	});

	$('.js-bookpanel')
		.on('click', function(){
			var elBook = document.querySelector('.header-site_book'),
				elMobl = document.querySelector('.nav-mobile');

			toggleClass(elBook, 'header-site_book__open');
			toggleClass(elMobl, 'nav-mobile__showbooking');
			removeClass(elMobl, 'nav-mobile__show');
		});

	$('.header-site_book_panel')
		.each(function(index, el){
			var elInner = el.querySelectorAll('.header-site_book_panel_text_inner'),
				elLinks = el.querySelectorAll('a[data-id]');

			$(el)
				.on('click mouseover', 'ul a', function(){

					for (var i = 0, l = elInner.length; i < l; i++) {
						addClass(elInner[i], 'hidden');
						if (elInner[i].id == this.getAttribute('data-id')) {
							removeClass(elInner[i], 'hidden');
						}
					}

					for (var i = 0, l = elLinks.length; i < l; i++) {
						removeClass(elLinks[i], 'active');
					}

					addClass(this, 'active');
				})
				.on('mouseout', function(){
					for (var i = 0, l = elInner.length; i < l; i++) {
						addClass(elInner[i], 'hidden');
					}

					for (var i = 0, l = elLinks.length; i < l; i++) {
						removeClass(elLinks[i], 'active');
					}
				})
				.on('mouseout', 'ul,div', function(event){
					event.stopPropagation();
				});
		});


	$('.js-nav-mobile-link')
		.on('click', function(event){
            var g = this.getAttribute('data-grid');
            if (!g) {
                return;
            } else {
                event.preventDefault();
                var el = document.getElementById('nav-mobile-grid-' + g);
                addClass(el, 'nav-mobile_child__show');
            }
		});


	$('.js-nav-mobile-back')
		.on('click', function(event){
			event.preventDefault();
			removeClass(this.parentNode.parentNode.parentNode, 'nav-mobile_child__show');
		});


	$('.js-nav-mobile')
		.on('click', function(event){
			event.preventDefault();
			var elNav = document.querySelector('.nav-mobile')
			toggleClass(elNav, 'nav-mobile__show');
			removeClass(elNav, 'nav-mobile__showbooking');
			removeClass(document.querySelector('.header-site_book'), 'header-site_book__open');
			removeClass(document.querySelector('.nav-mobile_child__show'), 'nav-mobile_child__show');

			$('body').toggleClass('nav__open');
		});


	// ---------------
	// Form Validation
	// ---------------
	// http://jqueryvalidation.org/validate
	$('.js-form-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			wrapper: 'div'
		});

		/*
			rules : {
				"emailconfirm": {
					equalTo: "#email"
				}
			},
			messages: {
				"emailconfirm": {
					equalTo: 'Please confirm your email address'
				}
			},
		*/
	});
	/*$('.js-form-newsletter-validate').each(function(index, element){
		var _form = $(element);

		_form.validate({
			errorContainer: element.querySelector('.js-error-container'),
			errorLabelContainer: element.querySelector('.js-error-container'),
			errorPlacement: function(err, el) {
				el.siblings('.error').remove();
				el.before(err);
			},
			wrapper: 'div'
		});
	});*/
	$('.js-form-newsletter-validate, .js-form-validate-alt, .js-form-validate-formz').each(function(index, element){
		var _form = $(element),
			_smry = $(element.querySelector('.js-error-container'));

		_form.validate({
			onclick: false,
			onkeyup: false,
            onfocusout: false,
            ignore: '',
			rules: {
                secondCaptcha: { required: true, },
                formzCaptcha: { required: true, },
            },
			showErrors: function(errorMap, errorList) {
				_smry.hide();

				var str = '';

				if (errorList.length > 0) {
					str = 'Please enter your ';
				} else {
					return;
				}

				for (var i = 0; i < errorList.length; i++) {
					if (errorList.length > 1 && i == (errorList.length - 1)) {
						str = str + ' and ' + errorList[i].message;
					} else if(i > 0) {
						str = str + ', ' + errorList[i].message;
					} else {
						str = str + errorList[i].message;
					}
				}

				str = str + ' below.'

				_smry.text(str).show();
			}
		});
	});

	$('.js-form-contact-validate').each(function(index, element){
		var _form = $(element),
			_smry = $(element.querySelector('.js-error-container'));

		_form.validate({
			onclick: false,
			onkeyup: false,
            onfocusout: false,
            ignore: '',
			rules: {
                firstCaptcha: { required: true, },
            },
			showErrors: function(errorMap, errorList) {
				_smry.hide();

				var str = '';

				if (errorList.length > 0) {
					str = 'Please enter your ';
				} else {
					return;
				}

				for (var i = 0; i < errorList.length; i++) {
					if (errorList.length > 1 && i == (errorList.length - 1)) {
						str = str + ' and ' + errorList[i].message;
					} else if(i > 0) {
						str = str + ', ' + errorList[i].message;
					} else {
						str = str + errorList[i].message;
					}
				}

				str = str + ' below.'

				_smry.text(str).show();
			}
		});
    });

	// -------
	// Cookies
	// -------
	// if (readCookie('policyAgeas') !== 'accepted') {
	// 	var _cookie = $('.cookie'),
	// 		_inner = _cookie.find('.inner');

	// 	_cookie
	// 		.removeClass('hide');

	// 	_cookie.height(_inner.outerHeight());

	// 	$('.js-accept-cookies')
	// 		.on('click', function(){
	// 			createCookie('policyAgeas', 'accepted', 365);
	// 			_cookie
	// 				.height(0);
	// 		});
	// } else {
	// 	createCookie('policyAgeas', 'accepted', 365);
	// }


	// -------------
	// Media Queries
	// -------------
	(function(){
		var updateTel = function(mq){
			if (mq.matches) {
				$('[data-tel]')
					.each(function(index, el){
						var _el = $(el);
						_el.attr('href', 'tel:'+_el.data('tel'));
					});
			} else {
				$('[data-tel]').removeAttr('href');
			}
		};
		if (window.matchMedia) {
			var mq = window.matchMedia( "(max-width: 767px)" );
			if (mq.addListener) {
				mq.addListener(updateTel);
			}
			updateTel(mq);
		}
	})();


	// -----
	// Video
	// -----
	$('.js-popup-video')
		.on('click', function(event){
			var _ovr = document.getElementById('overlay-video'),
				_ifr = _ovr.querySelector('iframe');

			_ifr.src = 'https://youtube.com/embed/'+this.getAttribute('data-video');
		});

	$('#overlay-video')
		.on('close.popup', function(){
			var _ifr = this.querySelector('iframe');
			_ifr.src = '';
		});



	// ---------
	// Polyfills
	// ---------

	// --------------------
	// Placeholder Function
	// --------------------
	function placeholderFunc(index, element){
		var ph = element.getAttribute('placeholder'),
			_input = $(this);

		_input.on({
			focus: function(){
				if (element.value == ph) {
					element.value = '';
					removeClass(element, 'placeholder-replacement');
				}
			},
			blur: function(){
				if (element.value == "") {
					element.value = ph;
					addClass(element, 'placeholder-replacement');
				}
			}
		}).blur();

	}


	// -----------
	// Placeholder
	// -----------
	if(!Modernizr.input.placeholder)
	{
		$('[placeholder]').each(placeholderFunc);
	}

	$('.js-print-directions')
		.on('click', function(event){
			event.preventDefault();
			var _form = $(this).parents('form');
			window.open(
				this.href+'?'+_form.serialize(),
				'',
				'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
			);
			// 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600'
			// 'width=626,height=436'
		});

	$('.js-print')
		.on('click', function(event){
			event.preventDefault();
			window.print();
		});


	// ---------
	// Scorecard
	// ---------
	$('.match-live')
		.each(function(index, element){
			var _this = $(element),
				_cols = _this.find('.col'),
				mq = {};

			if (window.matchMedia) {
				mq = window.matchMedia( "(min-width: 768px)" );
			} else {
				mq.matches = true;
			}

			_this.height();
			_cols
				.each(function(index, colEl){
					if (colEl.offsetHeight < _this.height() && mq.matches) {
						// Elements
						var spacers = colEl.querySelectorAll('.spacer');

						// Variables
						var gap = (_this.height() - colEl.offsetHeight) / spacers.length;

						for (var i = 0; i < spacers.length; i++) {
							spacers[i].style.paddingTop = gap + 'px';
						}
					}
				});
		});


	// --------
	// ScrollTo
	// --------
	$('.js-scrollto')
		.on('click', function(event){
			event.preventDefault();
			var element = document.getElementById(this.getAttribute('data-scrollto')),
				rect = element.getBoundingClientRect();
			$('body,html').animate({ scrollTop: rect.top + scrollTop() });
		});


	// ----
	// Hash
	// ----
	if(window.location.hash && window.location.hash != '') {
		switch (window.location.hash) {
			case "#footer-contact":
				$('.footer-contact .js-expand').trigger('toggle');
				break;
		}
	}


	// ----------
	// DatePicker
	// ----------
	$('.js-datepicker').each(function(index, element){
		var _el = $(element);

		_el
			.datepicker({
				dateFormat: 'dd/mm/yy'
			});
	});


	// ------------
	// Availability
	// ------------
	$('.content-block-booking')
		.on('submit', 'form', function(event){
			$(this)
				.find('.js-datepicker')
					.each(function(index, element){
						// Objects
						var _hdn = nextSibling(element.parentNode);

						// Variables
						var date = $(element)
							.datepicker('getDate'),
							str = '';

						if (date !== null && _hdn !== null) {
							str = '' + date.getFullYear() + pad(date.getMonth() + 1, 2) + date.getDate();
							_hdn.value = str;
						}

					});
		});


	// ---------
	// Scroll In
	// ---------
	(function(){
		var cache = {};
		cache.scrollTop = scrollTop();
		cache.windowHeight = _window.height();

		var _cb = $('h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6');

		_cb
			.on('test', function(){
				var rect = this.getBoundingClientRect();

				if (hasClass(this, 'inview')) return;

				if (rect.top < cache.windowHeight) {
					removeClass(this, 'outofview');
					addClass(this, 'inview');
				} else {
					addClass(this, 'outofview');
				}
			});

		_window
			.on('scroll', function(){
				cache.scrollTop = scrollTop();
				_cb.trigger('test');
			});

		_cb.trigger('test');
	})();

	// -------------------------------
	// Auto change year on tables page
	// -------------------------------
	$('.js-change-year')
		.on('change', function() {
			// $(this).parent().parent().submit();
			this.form.submit();
		});

	// Handle changing the league
	$('.js-change-league')
		.each(function(index, elSelect){
			// Elements
			var elLeagues = document.querySelectorAll('.content-block-league'),
				elOptions,
				elCurrent;

			// Functions
			var funcSetHistory = function(replaceState){
				var q = _ad.qString(location.search);

				if (!q) {
					q = {};
				}

				q.league = elSelect.value;

				var queryString = '';

				for (var key in q) {
					if (queryString !== '') queryString += '&';
					queryString += key+'='+q[key];
				}

				var href = location.protocol + '//' + location.host + location.pathname;

				if (history.replaceState && replaceState) {
					history.replaceState({}, '', href + '?'+queryString);
					return;
				}
				history.pushState({}, '', href + '?'+queryString);
			};
			var funcSelectChange = function(event, skipPushState){
				for (var i = 0, l = elLeagues.length; i < l; i++) {
					addClass(elLeagues[i], 'hidden');
					elCurrent = document.querySelector('[data-league="'+this.value+'"]');
					removeClass(elCurrent, 'hidden');
				}

				if (history.pushState && !skipPushState) {
					funcSetHistory();
				}

			};

			// Setup
			if (elLeagues.length < 1) {
				addClass(elSelect, 'hidden');
				addClass(elSelect.parentNode, 'hidden');
				return;
			}
			for (var i = 0, l = elLeagues.length; i < l; i++) {
				var elOpt = document.createElement('option');
				var title = elLeagues[i].getAttribute('data-league');
				elOpt.textContent = title;
				elOpt.value = title;
				elSelect.appendChild(elOpt);
			}
			elOptions = elSelect.querySelectorAll('option');

			var q = _ad.qString(location.search);
			if (q && q.league) {
				var foundValue = false;
				for (var i = 0, l = elOptions.length; i < l; i++) {
					if (elOptions[i].value === q.league) {
						elSelect.value = q.league;
						foundValue = true;
						break;
					}
				}

				if (!foundValue) {
					elSelect.value = elOptions[0].value;
					funcSetHistory(true);
				}
			}

			// Event binding
			$(elSelect)
				.on('change', funcSelectChange)
				.trigger('change', [true]);

			if (history.pushState) {
				window.onpopstate = function(){
					var q = _ad.qString(location.search);
					if (q.league) {
						elSelect.value = q.league;
					} else {
						elSelect.value = elSelect.querySelector('option').value;
					}

					$(elSelect)
						.trigger('change', [true]);
				};
			}

		});

	// Videos

	$('.video-embed-frame > .static-image-wrapper').on('click', function(e) {
		e.preventDefault();
		var $frame = $(this).closest('.video-embed-frame');
		var $iFrame = $frame.find('.video-iframe');
		var videoId = $frame.attr('data-video-id');

        $iFrame.attr('src', '//www.youtube.com/embed/'+videoId+'?rel=0&autoplay=1');
		$frame.addClass('active');
	});

    if($('.js-video-filter').length > 0) applyVideoFilters(urlToArray(window.location.href));
    $('.js-video-filter').on('change', function() {
    	var filters = {};
        $('.js-video-filter').each(function() {
        	var $selectEl = $(this);
            if($selectEl.val()) filters[$selectEl.attr('name')] = $selectEl.val();
		});
        setPageUrl(filters);
        applyVideoFilters(filters);
	});

	function applyVideoFilters(filters) {
		var matches = 0;
		var $videoContainer = $('.video-container');

		if(typeof filters.year !== 'undefined') $videoContainer.find('.js-video-filter[name="year"]').first().val(filters.year).trigger('change');
        if(typeof filters.area !== 'undefined') $videoContainer.find('.js-video-filter[name="area"]').first().val(filters.area).trigger('change');

        $videoContainer.find('.video-results .video-block').each(function() {
        	var $video = $(this);
        	$video.removeClass('show');
        	if((typeof filters.year === 'undefined'
					|| $video.attr('data-year') == filters.year)
				&& (typeof filters.area === 'undefined'
					|| $video.attr('data-area').indexOf(filters.area) >= 0)) {
                $video.addClass('show');
                matches++;
			}
		});
		if( matches === 0) {
			$videoContainer.find('.video-no-results').addClass('show');
        }
        else {
            $videoContainer.find('.video-no-results').removeClass('show');
		}
    }

    function urlToArray(url) {
        var request = {};
        if(url.indexOf('?') < 0) return request;
        var pairs = url.substring(url.indexOf('?') + 1).split('&');
        var i, pair;

        for (i = 0; i < pairs.length; i++) {
            if(!pairs[i])
                continue;
            pair = pairs[i].split('=');
            request[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
        }
        return request;
    }

    function setPageUrl(urlParams) {
		var path = (window.location.pathname).split('?')[0];
		var newurl = window.location.protocol + "//" + window.location.host + path;
		if(!$.isEmptyObject(urlParams)) newurl = newurl + '?' + $.param(urlParams);
		window.history.pushState({path: newurl}, '', newurl);
    }

    /* Search */
    $('.search-icon').on('click', function() {
			$('.header-site_search_box').toggleClass('open');

			if($('.nav-mobile').hasClass('nav-mobile__show')) {
				$('.js-nav-mobile').click();
				$('.header-site_search_box').addClass('open');
			}

			if($('.nav-mobile').hasClass('nav-mobile__showbooking')) {
				$('.js-bookpanel').click();
				$('.header-site_search_box').addClass('open');
			}
	})
});
